import * as Yup from 'yup';

export const validateEmail = ({ isRequired = true } = {}) => {
  const emailSchema = Yup.string().email('Please enter a valid email address');

  return isRequired ? emailSchema.required('*Required') : emailSchema;
};
